import { Col, Container, Row, media } from 'styled-bootstrap-grid';
import { Helmet } from "react-helmet";
import PageTitle from "../../../PageTitle/components/PageTitle";
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import PageNavigation from "../../../PageNavigation/components/PageNavigation";
import GetInTouch from "../../../GetInTouch/components/GetInTouch";
import ViewMoreLink from "../../../ViewMoreLink/components/ViewMoreLink";

const Img = styled.img`
  width: 100%;
`;
const H3 = styled.h3`
  font-weight: 400;
  font-size: 1.7rem;
  margin: 0 0 1rem;
`;
// const InfoTag = styled.p`
//   font-size: 1rem;
//   font-weight: 400;
//   text-transform: uppercase;
//   letter-spacing: 0.2rem;
//   color: #717476;
//   margin: 0 0 0.5rem;
// `;
const P = styled.p`
  color: #717476;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 2.5rem;
`;
const StyledRow = styled(Row)`
  padding-top: 4rem;
  padding-bottom: 4rem;
`;
const StyledCol = styled(Col)`
  margin-bottom: 4rem;
  
  ${media.lg`
    margin-bottom: 0;
  `}
`;

const IndustryTagWrap = styled.div`
  margin-bottom: 4rem;
`;
const IndustryTag = styled.div`
  display: inline-block;
  padding: 0 2rem;
  border: 1px solid #d7d7d7;
  border-radius: 5px;
  margin-right: 1rem;
  height: 3rem;
  border-radius: 2rem;
  text-align: center;
  font-size: 0.8rem;
  letter-spacing: 0.2rem;
  line-height: 3rem;
  text-transform: uppercase;
`;

const ServiceList = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  border-top: 1px solid #d7d7d7;
`;
const ServiceItem = styled.li`
  display: block;
  border-bottom: 1px solid #d7d7d7;
  padding: 1rem;
`;
const ServiceTag = styled.p`
  font-size: 1rem;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  color: #717476;
  margin: 0;
`;
const ServiceName = styled.p`
  color: #212529;
  font-size: 1.25rem;
  font-weight: 400;
  margin: 0;
`;

const LightWrap = styled.div`
  background: #fff;
  padding: ${({padding}) => (padding) ? padding : '4rem 0'};
`;
const TransparentWrap = styled.div`
  padding: 4rem 0;
`;
const NavCol = styled(Col)`
  font-weight: bold;
  margin-top: 1rem;
  margin-bottom: 2rem;
  text-align: center;
`;
const NavSpan = styled.span`
  font-size: 0.8rem;
  padding: 0 2rem;
  vertical-align:top;
`;

const Heb = (props) => {
  return <Fragment>
    <Helmet>
      <meta name="description" content=""/>
      <title>Case Study: H-E-B | RMG</title>
      <link rel="canonical" href={'https://www.rmgmedia.com/portfolio/' + props.match.params.caseStudy}/>
    </Helmet>
    <PageTitle heading="Case Study"
               subHeading="H-E-B"
    />
    <Container fluid>
      <Row>
        <Col col={12} noGutter={true}>
          <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/heb_hero.png" />
        </Col>
      </Row>
    </Container>
    <Container>
      <StyledRow>
        <StyledCol col={12} lg={6}>
          <IndustryTagWrap>
            <IndustryTag>Grocery</IndustryTag>
            <IndustryTag>Retail</IndustryTag>
            <IndustryTag>CPG</IndustryTag>
          </IndustryTagWrap>
          <H3>
            About H-E-B
          </H3>
          <P>
            Since their humble beginning in Kerville, Texas in 1905, H-E-B has been dedicated to innovation, customer satisfaction, and community service. In 1916, H-E-B added Ford Model T's to their transportation fleet to make their deliveries faster and more efficient. Today, they provide similarly innovative and modern shopping and delivery solutions to over 150 communities throughout Texas and northeast Mexico.
          </P>
          <P>
            H-E-B partnered with RMG to bring that same level of innovation to their online brand experience. RMG helped H-E-B systemize the management of over 60 stores - each with their own promotion, subscription, and domestic and international delivery options - resulting in a cohesive, high-quality experience that satisfies customers and reflects the H-E-B brand.
          </P>
        </StyledCol>
        <Col col={12} lgOffset={2} lg={4}>
          <H3>
            How We Helped
          </H3>
          <ServiceList>
            <ServiceItem>
              <ServiceTag>Creative</ServiceTag>
              <ServiceName>Mobile Responsive Design</ServiceName>
              <ServiceName>User Experience Design</ServiceName>
              <ServiceName>User Interface Design</ServiceName>
            </ServiceItem>
            <ServiceItem>
              <ServiceTag>Development</ServiceTag>
              <ServiceName>B2C & B2B Implementation</ServiceName>
              <ServiceName>Backend Development</ServiceName>
              <ServiceName>Frontend Development</ServiceName>
              <ServiceName>Software Architecture Design</ServiceName>
            </ServiceItem>
            <ServiceItem>
              <ServiceTag>Devops</ServiceTag>
              <ServiceName>Application &amp; Infrastructure Support</ServiceName>
              <ServiceName>Managed Cloud Hosting</ServiceName>
              <ServiceName>Software Development Lifecycle Management</ServiceName>
            </ServiceItem>
          </ServiceList>
        </Col>
      </StyledRow>
    </Container>
    <LightWrap>
      <Container>
        <Row>
          {/*<Col col={12} lg={6}>*/}
          {/*  <div><Img src="https://via.placeholder.com/1600x900" /></div>*/}
          {/*  <div><P>As their selection of bags and options continued to grow, Rickshaw partnered with RMG to streamline their online brand experience make it feel like it does in-store. To bring this level of customization online, RMG first replatformed Rickshaw from Magento 1 to Magento 2. During the data migration, RMG made updates to the infrastructure responsible for storing product and customer data, increasing security and functional reliability. These backend updates also allow Rickshaw to rapidly iterate on designs and store their new creations as product/option variations, greatly reducing the time-to-market for new offerings.</P></div>*/}
          {/*  <div><P>This feature immediately gave Rickshaw Bags a huge return on their investment by allowing them to remain open as an essential business and produce facemasks during the COVID-19 pandemic, increasing their pageviews and conversation rate by over 400% and their revenue by almost 500%.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/600x600" /></div>*/}
          {/*  <div><P>After transforming Rickshaw's core digital experience, the same treatment was applied to the rest of the business by adding new shipping methods and options, upgrading their invoice processing, and revamping their blog. Together, these changes help Rickshaw scale their business as their options continue to expand and attract new audiences through their strong content-to-commerce funnel. By working with RMG, Rickshaw Bagworks was able to bring their renowned in-store experience online and expand their reach well beyond their San Francisco storefront.</P></div>*/}
          {/*</Col>*/}
          {/*<Col col={12} lg={6}>*/}
          {/*  <div><P>At the core of Rickshaw's brand experience is the ability to customize a bag's flap, body, inner lining, bindings, buckles, labels, and straps, each of which comes in multiple colors and fabrics. Because of their extraordinary selection, Rickshaw staff's knowledgeable designers to help customers build the best bags based on their needs. In addition, Rickshaw designs and manufactures many custom fabrics, which greatly expands the audiences and applications their products cater to.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/800x1000" /></div>*/}
          {/*  <div><P>On the frontend, RMG built a specialized product customizer which allowed for multiple interacting filters, such as part color and fabric. This customizer also allows customers to make unique, personalized color variations which can be applied across all of Rickshaw's products. In addition, RMG redesigned Rickshaw's entire customer journey to be mobile-first, allowing customers to navigate the customization process with ease regardless of the device they use. As part of this redesign, RMG restyled most of the imagery across the site, even adding support for moving GIF images. We also streamlined Rickshaw's product, catalog, cart, and checkout pages to minimize friction and provide better responsiveness.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/1600x900" /></div>*/}
          {/*</Col>*/}
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/heb_img_01.png" />
          </Col>
          <Col col={12} lg={6}>
            <P>H-E-B is one of America's largest private companies, with over 340 stores and 100,000 employees in Texas and Mexico. In addition to retail stores, H-E-B operates several domestic manufacturing facilities, producing many of their own brand products. H-E-B's growth over their 115-year history is closely tied to their progressive vision for grocery and their innovations in how they connect customers to their products. Today, they operate over 65 stores in Mexico, bringing their commitment to quality and customer service to international markets.</P>
          </Col>
        </Row>
      </Container>
    </LightWrap>
    <TransparentWrap>
      <Container>
        <Row>
          <Col col={12} lg={6}>
            <P>H-E-B partnered with RMG to modernize their brand experience and systemize the management of delivery and subscription options across their stores. RMG helped H-E-B Mexico move from Magento 1 to Magento 2 and Amazon Web Services when their backend systems demanded more in-house management. Using our own management state-of-the-art open source tool, Conductor, RMG improved H-E-B's code deployment process, minimizing the downtime associate with launching new and innovative features. RMG helped H-E-B Mexico launch many such features, including a custom delivery method manager, subscription manager, promotion manager, quantity calculator, a multi-currency international payment gateway and shipping calculator.</P>
          </Col>
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/heb_img_02.png" />
          </Col>
        </Row>
      </Container>
    </TransparentWrap>
    <LightWrap>
      <Container>
        <Row>
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/heb_img_03.png" />
          </Col>
          <Col col={12} lg={6}>
            <P>Because many grocery products have multiple cost models (price per unit, price per pack, price per weight, etc.), RMG custom built a robust quantity calculator that helped manage inventory and orders, regardless of the options selected by online shoppers. That calculator was also helpful in Building Combo Loco, H-E-B's custom promotion portal that allows customers to see every type of promotional discount all in one place. Instead of only seeing it applied after the right items are added to their cart. The same type of systematic management was tied into their subscriptions because each store has its own reservation rules based on stocked inventory and time of day.</P>
          </Col>
        </Row>
      </Container>
    </LightWrap>
    <TransparentWrap>
      <Container>
        <Row>
          <Col col={12} lg={6}>
            <P>H-E-B is known for their innovations and nowhere is that more apparent than in their diverse delivery methods. From lockers with keycodes to motorcycle delivery, H-E-B provides a variety of options for every locale, all of which need to be available to their online shoppers. To facilitate this, RMG built a complex delivery manager that allowed H-E-B to set shipping options based on the individual store, time of day, day of week, and other custom parameters.</P>
            <P>Our partnership with H-E-B extends past replatforming their online brand experience and delivering innovative features. RMG standardized their development process and helped H-E-B Mexico learn to manage, test, and deploy their own code. As a result, H-E-B can keep bringing their 115-year-old culture of innovation to their online experience, resulting in continual growth and delighted customers.</P>
          </Col>
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/heb_img_04.png" />
          </Col>
        </Row>
      </Container>
    </TransparentWrap>
    <Container>
      <Row>
        <NavCol col={12}>
          <ViewMoreLink textColor="#000" arrowWidth='0.6rem' directionReversed
                        to={`/portfolio/black-ovis`}
                        buttonText="Black Ovis" />
          <NavSpan>/</NavSpan>
          <ViewMoreLink textColor="#000" arrowWidth='0.6rem' to={`/portfolio/anova-furnishings`}
                        buttonText="Anova Furnishings" />
        </NavCol>
      </Row>
    </Container>
    <GetInTouch title="Get In Touch"
                text="You could be our next case study."
                buttonText="Let's talk"
                useArrow
                useBorderTop
    />
    <PageNavigation prev="capabilities" next="insights" />
  </Fragment>;
};

export default withRouter(Heb);